/**
 * AM.One API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdrSummaryDto { 
    id: string;
    type: AdrSummaryDto.TypeEnum;
    title: string;
    /**
     * Document status enumeration (values match the ADR frontmatter schema in schemas/adr.schema.json)
     */
    status: AdrSummaryDto.StatusEnum;
    author: string;
    /**
     * Latest Git commit author for the document file, when available.
     */
    lastEditedBy?: string | null;
    created: string;
    lastModified?: string | null;
    commitTimestamp?: string | null;
    relativePath: string;
    branchName: string;
}
export namespace AdrSummaryDto {
    export const TypeEnum = {
        Adr: 'adr'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
    export const StatusEnum = {
        Draft: 'Draft',
        Accepted: 'Accepted',
        Deprecated: 'Deprecated',
        Superseded: 'Superseded'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


